const axios = require('axios')
import store from '../state/store'
import router from '../router/index'

let axiosCreate = axios.create({
  baseURL: `${process.env.VUE_APP_URL}/api/v1`,
  headers: {
    //Authorization: `Bearer ${store.state.token}`
  },
  validateStatus: function(status) {
    return status // Resolve only if the status code is less than 500
  }
})

axiosCreate.interceptors.request.use(request => {
  if (request.url === 'public/registerUser') return request

  request.headers['authorization'] =
    store.state.bearerToken ?? store.state.anonymousToken ?? null
  return request
})

axiosCreate.interceptors.response.use(response => {
  if (
    !response.config.url.includes('authorization') &&
    response.status === 401
  ) {
    logout()
  }

  return response
})

let api = axios.create({
  baseURL: `${process.env.VUE_APP_URL}/api`,
  headers: {
    //Authorization: `Bearer ${store.state.token}`
  },
  validateStatus: function(status) {
    return status // Resolve only if the status code is less than 500
  }
})

api.interceptors.request.use(request => {
  if (request.url === '/v3/shop/authorization/login') return request

  request.headers['authorization'] =
    store.state.bearerToken ?? store.state.anonymousToken ?? ''
  return request
})

api.interceptors.response.use(response => {
  if (
    !response.config.url.includes('authorization') &&
    response.status === 401
  ) {
    logout()
  }

  return response
})

function logout() {
  store.commit('unsetUser')
  store.commit('unsetCart')

  router.push({ name: 'index', query: { sessionExpired: true } })
}

module.exports = { axiosCreate, api }
